import { forwardRef, ReactNode, useId } from "react";
import { SvgIcon, Tooltip, Box, BoxProps } from "@mui/material";
import styles from "./ErrorIndicator.module.css";
import Error from "./images/error.svg?react";
import i18nPackage from "../../i18n/i18n";

export default function CoreErrorIndicator({ error, size }: { error?: ReactNode; size?: number }) {
	// Talked to Olha and she said to make this tab focusable with aria label AND aria-decribedby
	const tooltipId = useId();
	const ariaLabel = i18nPackage.t("coreComponents.coreError.warning");

	return error && typeof error !== "boolean" ? (
		<Tooltip title={error} id={tooltipId}>
			<SvgIcon
				aria-describedby={tooltipId}
				aria-label={ariaLabel}
				className={styles.indicator}
				tabIndex={0}
				sx={{ fontSize: size }}
				focusable={true}
				aria-hidden={undefined}
			>
				<Error />
			</SvgIcon>
		</Tooltip>
	) : null;
}

export type CoreErrorIndicatorRowProps = BoxProps & {
	error?: ReactNode;
};

export const CoreErrorIndicatorRow = forwardRef<HTMLDivElement, CoreErrorIndicatorRowProps>(
	function CoreErrorIndicatorRow({ error, children, className, ...boxProps }, ref) {
		return (
			<Box {...boxProps} className={`${styles.controlTooltipRow} ${className || ""}`} ref={ref}>
				{children}
				<CoreErrorIndicator error={error} />
			</Box>
		);
	},
);
